import React from 'react';

import { AtlassianLogo } from '@atlaskit/logo';

const AtlassianLogoDefault = (): React.JSX.Element => {
	return <AtlassianLogo />;
};

export default AtlassianLogoDefault;
